import EnumClass, { build } from '../EnumClass';
import data, { PaymentOverrideReasonId, PaymentOverrideReasonData } from './data';
import * as Translations from './translations';

export class PaymentOverrideReason extends EnumClass<PaymentOverrideReasonId, PaymentOverrideReasonData> {
  public get getName() {
    return Translations.name[this.id];
  }
}

export const {
  list: PAYMENT_OVERRIDE_REASONS,
  getById: getPaymentOverrideReasonById,
  marshaller: PaymentOverrideReasonMarshaller,
} = build<PaymentOverrideReasonId, PaymentOverrideReasonData, PaymentOverrideReason>(
  'PaymentOverrideReasonEnum',
  data,
  PaymentOverrideReason,
);
